import { render, staticRenderFns } from "./videoWriting.vue?vue&type=template&id=651569f8&"
import script from "./videoWriting.vue?vue&type=script&lang=js&"
export * from "./videoWriting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports